export default __webpack_public_path__ + "static/media/Provider_innw.f2e76943.svg";